import { axios } from 'lib/axios';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';
import { useAuth } from 'lib/auth';

const createRequest = async (values) => {
  const formData = new FormData();

  formData.append('title', values.title);
  formData.append('description', values.description);
  formData.append('content', values.content);
  formData.append('tag', values.tag);
  formData.append('file', values.picture.file);
  if (values.creatorID) {
    formData.append('creator_id', values.creatorID);
  }
  formData.append('file_ext', 'png');

  return await axios.post(`/api/blogs`, formData);
};

export const useCreate = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useAuth();

  return useMutation({
    mutationFn: (data) => createRequest({last_updated_user_id: user.user_id, ...data}),
    onSuccess: () => {
      enqueueSnackbar('Blog created successfully', {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
